import { render, staticRenderFns } from "./Comrads.vue?vue&type=template&id=1a71052f&scoped=true"
import script from "./Comrads.vue?vue&type=script&lang=js"
export * from "./Comrads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a71052f",
  null
  
)

export default component.exports